import * as React from 'react';
import TextField from '@mui/material/TextField';
// import { convertPixelsToRem } from '../../../../../helpers';
import { makeStyles } from '@mui/styles';
import {
  TableContainer,
  TableHead,
  TableRow,
  Table,
  TableBody,
  TableCell,
  MenuItem,
  Checkbox,
  InputAdornment,
  Typography,
  FormControl,
  InputLabel,
  Select
} from '@mui/material';
import { withStyles } from '@mui/styles';

/**
 *
 * Converts pixels to rems with base pixel unit of 16px
 *
 * @param  {number} unitValue - number of pixels
 * @returns string - rem value
 */
 const convertPixelsToRem = (unitValue) => {
  return `${(unitValue / 16).toFixed(2)}rem`;
};

const SegmentsTable = (props) => {
  const tableUnlocked = props.status !== "SUCCESSFUL";

  // used to setup styles for containers and tables
  const useStyles = makeStyles({
    container: {
      borderRight: '1px solid #797979',
      fontSize: `${convertPixelsToRem(12)} !important`,
    },
    table: {
      minWidth: 650,
    },
    tableRightBorder: {
      borderWidth: 0,
      borderRightWidth: 1,
      borderColor: 'black',
      borderStyle: 'solid',
    },

  });

  // used to setup styles for table rows
  const StyledTableRow = withStyles((theme) => ({
    root: {
      '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: '#eff2f8',
      },
    },
  }))(TableRow);

  // used to setup styles for short text fields
  const ShortTextField = withStyles((theme) => ({
    root: {
      width: 80, // 135
      '& .MuiInputBase-root': {
        height: 20,
        fontSize: `${convertPixelsToRem(12)} !important`,
      },
    },
  }))(TextField);


  const handleTextfieldChange = async (e, cbIdx, column, section, stationIdx, props) => {
    props.update(parseFloat(e.target.value), `data.stations[${stationIdx}].segments[${cbIdx}].${column}`);
  };

  const segmentCenterColumnHeaders = ['SEG NO', 'HZ', 'HX', 'SKIN THICK', 'SKIN WIDTH', 'STIFF AREA', 'Z BAR STIFF', 'E L PATH', 'C KB SHR', 'ALL CMP LOAD', 'ALL SHR U', 'ALL SHR L', 'ALL TEN', 'K TEST', 'DELTA SKIN AREA'];
  const segmentCenterColumns = ['sn', 'z', 'x', 'skin_t', 'skw', 'stfa', 'zbar_st', 'el_path', 'ckb_shear', 'comp_all', 'shr_all_u', 'shr_all_l', 'tens_all', 'k_test', 'delta_skin_area'];

  const segmentOutboardColumnHeaders = ['TCR SK', 'SEG NO', 'SKIN THICK', 'SEG AREA', 'SKIN AREA', 'E L PATH', 'X', 'Z', 'K TEST', 'DELTA Z', 'Z BAR STIFF', 'TAN THETA', 'TAN PHI', 'ALL CMP LOAD', 'ALL TEN', 'DELTA SKIN AREA'];
  const segmentOutboardColumns = ['tcr_sk', 'sn', 'skin_t', 'seg_area', 'skin_area', 'el_path', 'x', 'z', 'k_test', 'delta_z', 'zbar_st', 'tan_theta', 'tan_phi', 'comp_all', 'tens_all', 'delta_skin_area'];


  const leftBorderColumns = ['id']

  //const centerColumnWidth = "7.7%"

  // const getField = (loadcase, column, cbIdx) => {
  //   return (
  //     <ShortTextField
  //       defaultValue={getValue(loadcase, column)}
  //       variant="outlined"
  //       onBlur={(e) => handleTextfieldChange(e, cbIdx, column, props)}
  //     />
  //   );

  // };

  // const getValue = (loadcase, column) => {
  //   return loadcase[column];
  // };

  const getField = (segment, column, cbIdx, stationIdx, section='', unit='') => {
    const value = getValue(segment, column, section)
    // console.log(column)
    // console.log(segment)
    // console.log(value)
    if (column === "type") {
      return (
        <ShortTextField
        select
          name={column}
          defaultValue={value}
          error={value ? Boolean(value.error) : false}
          focused={value ? value.focus : false}
          type={'text'}
          variant="outlined"
          InputProps={ unit ? {
            endAdornment:
            <InputAdornment position="end">
              <Typography variant={'caption'} style={{ color: "rgba(0,0,0,0.54)" }}>{unit}</Typography>
            </InputAdornment>
          } : {}}
          onBlur={(e) => handleTextfieldChange(e, cbIdx, column, section, stationIdx, props)}
        >
          <MenuItem value={1}>Radial</MenuItem>
          <MenuItem value={2}>Tangential</MenuItem>
          <MenuItem value={3}>Moment</MenuItem>
        </ShortTextField>
      )
    }
    return (
      <ShortTextField
        name={column}
        defaultValue={value}
        error={value ? Boolean(value.error) : false}
        focused={value ? value.focus : false}
        type={'text'}
        variant="outlined"
        InputProps={ unit ? {
          endAdornment:
          <InputAdornment position="end">
            <Typography variant={'caption'} style={{ color: "rgba(0,0,0,0.54)" }}>{unit}</Typography>
          </InputAdornment>
        } : {}}
        onBlur={(e) => handleTextfieldChange(e, cbIdx, column, section, stationIdx, props)}
      />
    );

  };

  const getValue = (segment, column, section='') => {
    return segment[column];
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked && props.selectedStation && props.selectedStation.loads) {
      const newSelecteds = props.selectedStation.loads.map((_, i) => i);
      props.setSelectedSegments(newSelecteds);
      return;
    }
    props.setSelectedSegments([]);
  };

  const handleClick = (event, loadIndex) => {
    const selectedIndex = props.selectedSegments.indexOf(loadIndex);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(props.selectedSegments, loadIndex);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(props.selectedSegments.slice(1));
    } else if (selectedIndex === props.selectedSegments.length - 1) {
      newSelected = newSelected.concat(props.selectedSegments.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        props.selectedSegments.slice(0, selectedIndex),
        props.selectedSegments.slice(selectedIndex + 1)
      );
    }

    props.setSelectedSegments(newSelected);
  };

  const isSelected = (load) => props.selectedSegments.indexOf(load) !== -1;

  const rowCount = () =>
    props.selectedStation && props.selectedStation.loads ? props.selectedStation.loads.length : 0;

  const columnHeaders = props.analysis === 3 ? segmentCenterColumnHeaders : segmentOutboardColumnHeaders;
  const colunms = props.analysis === 3 ? segmentCenterColumns : segmentOutboardColumns;
  const columnWidth = props.analysis === 3 ? "6.7%" : "6.5%";

  // overflowX: 'unset' to avoid small vertical scroll issue (space after the last row)
  return (
    <TableContainer style={{overflowX: 'unset' }}>
      <Table className={useStyles.table} stickyHeader aria-label="simple table">
        <TableHead>
          <TableRow>
            {tableUnlocked && (
              <TableCell rowSpan={2}padding="checkbox" align='center' style={{padding: 2}} width="5%">
                <Checkbox
                  color="primary"
                  size="small"
                  style={{ padding: 2 }}
                  indeterminate={
                    props.selectedSegments.length > 0 && props.selectedSegments.length < rowCount()
                  }
                  checked={rowCount() > 0 && props.selectedSegments.length === rowCount()}
                  onChange={handleSelectAllClick}
                  inputProps={{
                    'aria-label': 'select all circuit breakers',
                  }}
                />
              </TableCell>
            )}
            {
              columnHeaders.map((header) => {

                return(
                <TableCell align="center" width={columnWidth} style={{padding: 0}}><b>{header}</b></TableCell>
                )})
            }

          </TableRow>
        </TableHead>
        <TableBody>
          {props.selectedStation
            ? props.selectedStation.segments.map((segment, segmentIndex) => {

                // console.log("Segment=" + JSON.stringify(segment))
                const isItemSelected = isSelected(segmentIndex);

                return (
                  <StyledTableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={`segment-${segmentIndex}`}
                    selected={isItemSelected}
                    // style={{ height: 41 }}
                  >
                    {tableUnlocked && (
                      <TableCell padding="checkbox" align='center' style={{padding: 2}} width="5%">
                        <Checkbox
                          color="primary"
                          size="small"
                          style={{ padding: 2 }}
                          checked={isItemSelected}
                          onClick={(event) => handleClick(event, segmentIndex)}
                        />
                      </TableCell>
                    )}

                    {colunms.map( column => {
                      return (
                        <TableCell
                          align={'center'}
                          key={column}
                          width={columnWidth}
                          style={{
                            padding: 0,
                          }}
                        >
                          {tableUnlocked
                            ? getField(segment, column, segmentIndex, props.stationIdx)
                            : getValue(segment, column)}
                        </TableCell>
                      )
                    })}
                  </StyledTableRow>
                );
              })
            : null}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SegmentsTable;
